module.exports = __webpack_public_path__ + "img/ico-budgee-white.44da19a5.svg";